import React from "react"

const Updates = () => (
  <section className="py-20">
    <div className="container mx-auto px-5 max-w-screen-md">
      <h1 className="text-3xl mb-5 font-black font-heading">Updates</h1>
      <div className="mb-8">
        <h2 className="text-xl font-bold text-gray-800">Update Title</h2>
        <span className="text-sm text-gray-700 inline-block mb-4">Posted On: September 18th, 2020</span>
        <div className="h-64 bg-gray-500 flex items-center justify-center text-gray-700">Update Image</div>
      </div>
      <div className="mb-8">
        <h2 className="text-xl font-bold text-gray-800">Update Title</h2>
        <span className="text-sm text-gray-700 inline-block mb-4">Posted On: September 18th, 2020</span>
        <div className="h-64 bg-gray-500 flex items-center justify-center text-gray-700">Update Image</div>
      </div>
      <div>
        <h2 className="text-xl font-bold text-gray-800">Update Title</h2>
        <span className="text-sm text-gray-700 inline-block mb-4">Posted On: September 18th, 2020</span>
        <div className="h-64 bg-gray-500 flex items-center justify-center text-gray-700">Update Image</div>
      </div>
    </div>
  </section>
)

export default Updates